The underlying source for the item.

For example, items related to an application process would note the job board or other channel that sourced the application.
